import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Space, Typography, DatePicker, message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';

const { Title } = Typography;

const RelatorioProdutos = () => {
  const [tipoRelatorio, setTipoRelatorio] = useState('vendidos_por_dia'); // 'vendidos_por_dia', 'vendidos_por_mes', 'vendidos_por_ano'
  const [dataSelecionada, setDataSelecionada] = useState(dayjs());
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  // Mapeia tipoRelatorio para tipo picker do DatePicker
  const pickerType = {
    vendidos_por_dia: 'date',
    vendidos_por_mes: 'month',
    vendidos_por_ano: 'year',
  };

  const fetchRelatorio = async () => {
    setLoading(true);
    try {
      const params = {
        tipo: tipoRelatorio,
        data:
          tipoRelatorio === 'vendidos_por_dia'
            ? dataSelecionada.format('YYYY-MM-DD')
            : tipoRelatorio === 'vendidos_por_mes'
            ? dataSelecionada.format('YYYY-MM')
            : dataSelecionada.format('YYYY'),
      };
      const response = await axios.get('/api/relatorios/produtos', { params });
      setDados(response.data);
    } catch (error) {
      console.error(error);
      message.error('Erro ao carregar dados do relatório.');
      setDados([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRelatorio();
  }, [tipoRelatorio, dataSelecionada]);

  const columns = [
    {
      title: 'Produto',
      dataIndex: 'nome_produto',
      key: 'nome_produto',
    },
    {
      title: 'Quantidade Vendida',
      dataIndex: 'quantidade_vendida',
      key: 'quantidade_vendida',
      sorter: (a, b) => a.quantidade_vendida - b.quantidade_vendida,
    },
    {
      title: 'Data',
      dataIndex: 'data',
      key: 'data',
      render: (text) => (text ? dayjs(text).format('DD/MM/YYYY') : '-'),
    },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }} wrap>
        <select
          value={tipoRelatorio}
          onChange={(e) => setTipoRelatorio(e.target.value)}
          style={{ minWidth: 200, padding: 6, fontSize: 16 }}
        >
          <option value="vendidos_por_dia">Dia</option>
          <option value="vendidos_por_mes">Mês</option>
          <option value="vendidos_por_ano">Ano</option>
        </select>

        <DatePicker
          picker={pickerType[tipoRelatorio]}
          value={dataSelecionada}
          onChange={setDataSelecionada}
          allowClear={false}
          style={{ minWidth: 150 }}
        />

        <Button type="primary" onClick={fetchRelatorio}>
          Buscar
        </Button>
      </Space>

      <Card>
        <Table
        dataSource={dados}
        columns={[
            { title: 'Nome', dataIndex: 'NOME', key: 'NOME' },
            { title: 'Quantidade Vendida', dataIndex: 'quantidade_vendida', key: 'quantidade_vendida' },
        ]}
        loading={loading}
        rowKey={(record) => record.id_produto || record.nome_produto}
        pagination={{ pageSize: 10 }}
        size="small"
        />
      </Card>
    </div>
  );
};

export default RelatorioProdutos;
